"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const FormalReviewClient_1 = require("client/FormalReviewClient");
const HelperUtils_1 = require("utils/HelperUtils");
const Dropdown_1 = __importDefault(require("components/design-system/dropdown/Dropdown"));
const Trigger_1 = __importDefault(require("components/design-system/dropdown/Trigger"));
const Shimmer_1 = __importDefault(require("components/design-system/shimmer/Shimmer"));
require("components/formal-review/calibration/ScoreHistoryBox.scss");
const Avatar_1 = __importDefault(require("components/shared/Avatar"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TruncateParagraph_1 = __importDefault(require("components/shared/TruncateParagraph"));
const Modal_1 = __importDefault(require("components/shared/modal/Modal"));
const CalibrationModalSkeleton_1 = __importDefault(require("./CalibrationModalSkeleton"));
const CalibrationModal = ({ prevScore, userData, closeModal, submitModal, scoringMarks, isPerfCategory, calibrationModalLoading = false, cycleId, currentCalibratorId }) => {
    const queryClient = (0, react_query_1.useQueryClient)();
    const queryData = queryClient.getQueryData([
        'calibration',
        userData?.userId,
        userData?.placementId
    ]);
    const data = queryData?.data;
    const getCurrentScore = () => {
        return isPerfCategory
            ? data?.score?.finalPerformanceCategory.performanceCategory
            : data?.score?.final?.score;
    };
    const currentScore = getCurrentScore();
    const [inputValue, setInputValue] = (0, react_1.useState)(currentScore || 0);
    const [inputComment, setInputComment] = (0, react_1.useState)('');
    const [inputPerfCategory, setInputPerfCategory] = (0, react_1.useState)({});
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [calibrationsCount, setCalibrationsCount] = (0, react_1.useState)(0);
    const handleChangeDropdown = (value) => {
        setInputPerfCategory({ id: value?.id, name: value?.name });
    };
    const scoringMarksOptions = (0, HelperUtils_1.setDropdownOptions)(scoringMarks, 'name', handleChangeDropdown, '', '');
    const updateInputValue = (e) => {
        setInputValue(e.target.value);
    };
    const updateCommentValue = (e) => {
        setInputComment(e.target.value);
    };
    const getFinalScore = () => {
        if (currentScore) {
            return Number(currentScore).toFixed(2);
        }
        return '0';
    };
    const result = (prevScore || 0) - (Number(inputValue) || 0);
    const isInputValueMoreThanPrevScore = Number(inputValue) > (prevScore || 0);
    const modalProps = {
        className: 'w-[600px] modal-calibration',
        title: calibrationModalLoading ? (react_1.default.createElement(Shimmer_1.default, { width: 512, height: 24 })) : (`${(0, HelperUtils_1.getNumberWithOrdinal)(calibrationsCount)} Calibration`),
        withCloseIcon: true,
        eventOnClickClose: closeModal,
        withPrimaryBtn: {
            title: (0, HelperUtils_1.getObjectiveLocale)('Submit Score'),
            onClick: () => {
                setIsLoading(true);
                submitModal(userData?.userId, userData?.placementId, Number(inputValue), inputComment, inputPerfCategory.id);
            },
            disabled: inputComment?.trim() == '',
            dataCy: 'button-submit-score-calibration',
            isLoading,
            showSkeleton: calibrationModalLoading,
            tooltipText: 'Comment is required'
        },
        withSecondaryBtn: {
            title: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
            onClick: closeModal,
            datacy: 'cancel',
            showSkeleton: calibrationModalLoading
        }
    };
    (0, react_1.useEffect)(() => {
        const getData = async () => {
            const { data } = await (0, FormalReviewClient_1.getCurrentCalibrationScore)(cycleId, userData?.userId, { calibratorId: currentCalibratorId });
            if (data) {
                setCalibrationsCount(data?.calibrationsCount + 1 || 0);
            }
        };
        getData();
        if (currentScore)
            setInputValue(currentScore);
        const defaultPerfCategory = scoringMarks?.filter((scoringMark) => scoringMark?.name === currentScore)?.[0];
        setInputPerfCategory({
            id: defaultPerfCategory?.id,
            name: defaultPerfCategory?.name
        });
        // eslint-disable-next-line
    }, []);
    (0, react_1.useEffect)(() => {
        window.addEventListener('beforeunload', closeModal, {
            capture: true
        });
        // eslint-disable-next-line
    }, []);
    return (react_1.default.createElement(Modal_1.default, { ...modalProps }, calibrationModalLoading ? (react_1.default.createElement(CalibrationModalSkeleton_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "flex justify-between items-center h-[56px] relative shadow-raised bg-transparent py-[0px] px-[0px] mb-[16px] rounded-[8px]" },
            react_1.default.createElement("div", { className: "flex items-center py-[12px] pl-[16px] w-[calc(100%-135px)]" },
                react_1.default.createElement(Avatar_1.default, { name: userData?.name || '', src: userData?.profilePicture || '', size: 32 }),
                react_1.default.createElement("div", { className: "ml-[16px] flex flex-col w-full overflow-hidden" },
                    react_1.default.createElement(TruncateParagraph_1.default, { className: "typography-h400" }, userData?.name || '-'),
                    react_1.default.createElement(TruncateParagraph_1.default, { className: "typography-h100 typography-secondary" }, userData?.jobTitle || '-'))),
            react_1.default.createElement("div", { className: "flex flex-col justify-center items-end bg-n-200 h-full pr-[16px] pl-[24px] rounded-[8px]" },
                react_1.default.createElement("span", { className: "self-end typography-h100" }, (0, HelperUtils_1.getObjectiveLocale)('Current Score')),
                react_1.default.createElement("div", { className: "typography-h600 w-max" }, isPerfCategory ? (currentScore) : (react_1.default.createElement(react_1.default.Fragment, null,
                    getFinalScore(),
                    ' ',
                    userData?.statusName && (react_1.default.createElement("span", { className: "typography-h600", style: { color: `#${userData?.statusColorHex}` } },
                        "(",
                        userData?.statusName,
                        ")"))))))),
        react_1.default.createElement("div", { className: "modal-body" },
            react_1.default.createElement("div", { className: "mb-[16px]" },
                isPerfCategory && (react_1.default.createElement(Dropdown_1.default, { customClass: "w-full" },
                    react_1.default.createElement(Dropdown_1.default.Trigger, null,
                        react_1.default.createElement(Trigger_1.default, { customWrapperClass: "w-full !h-auto", text: inputPerfCategory?.name, label: "New Calibration Score" })),
                    react_1.default.createElement(Dropdown_1.default.MenuItems, { options: scoringMarksOptions }))),
                !isPerfCategory && (react_1.default.createElement("label", null,
                    react_1.default.createElement("div", { className: "relative input-calibration-score" },
                        react_1.default.createElement("input", { value: inputValue, type: "number", className: "num-contain w-[276px]", onChange: (e) => updateInputValue(e), "data-cy": "input-score-calibration" }),
                        react_1.default.createElement(SVGIcon_1.default, { size: 20, customClass: "close-icon cursor-pointer absolute right-0", iconName: "icon-cancel", fillColor: "var(--n-600)", onClick: () => setInputValue(0) })),
                    react_1.default.createElement("span", { className: "direction" },
                        react_1.default.createElement("p", { className: "typography-h400 typography-paragraph", id: isInputValueMoreThanPrevScore ? 'plus' : 'minus' }, `${isInputValueMoreThanPrevScore ? '+' : '-'}${Math.abs(result)?.toFixed(1)}`),
                        ' ')))),
            react_1.default.createElement("div", { className: "mt-[16px]" },
                react_1.default.createElement("p", { className: "typography-h100 typography-secondary mb-[8px]" }, (0, HelperUtils_1.getObjectiveLocale)('Comment (Required)')),
                react_1.default.createElement("textarea", { className: `px-[16px] py-[6px] ${inputComment?.trim() ? '' : 'border-red'}`, rows: 2, cols: 50, onChange: (e) => updateCommentValue(e), "data-cy": "text-area-calibration-comment", value: inputComment })))))));
};
exports.default = CalibrationModal;
